import { render, staticRenderFns } from "./UserAnswer.vue?vue&type=template&id=1bbe2fa4&"
import script from "./UserAnswer.vue?vue&type=script&lang=js&"
export * from "./UserAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports